import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

export default function BurgerMenu(props: Partial<SVGProps<any>>) {
  return (
<svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<line x1="24.75" y1="1.25" x2="1.25" y2="1.25" stroke="#212021" strokeWidth="2.5" strokeLinecap="round"/>
<line x1="24.75" y1="9.25" x2="1.25" y2="9.25" stroke="#212021" strokeWidth="2.5" strokeLinecap="round"/>
<line x1="24.75" y1="17.25" x2="1.25" y2="17.25" stroke="#212021" strokeWidth="2.5" strokeLinecap="round"/>
</svg>

  )
}